import React from 'react';
import { Box, Typography } from '@mui/material';
import { alpha } from '@mui/material/styles';

const TimelineMultipleMomentsIndicator = ({
  momentCount = 0,
  compact = false,
  sx = {},
}) => {
  const normalizedCount = Number(momentCount);
  if (!Number.isFinite(normalizedCount) || normalizedCount <= 1) {
    return null;
  }

  const label = `${normalizedCount} ${normalizedCount === 1 ? 'moment' : 'moments'}`;

  return (
    <Box
      component="span"
      aria-label={label}
      title={label}
      sx={{
        display: 'inline-flex',
        alignItems: 'center',
        gap: 0.5,
        px: compact ? 0.8 : 0.9,
        py: compact ? 0.32 : 0.38,
        borderRadius: 999,
        border: `1px solid ${alpha('#7C6AAE', 0.34)}`,
        bgcolor: alpha('#D9D1EE', 0.58),
        color: '#5F4F91',
        fontSize: compact ? '0.7rem' : '0.72rem',
        fontWeight: 800,
        lineHeight: 1,
        whiteSpace: 'nowrap',
        flexShrink: 0,
        ...sx,
      }}
    >
      <Box
        sx={{
          width: compact ? 5 : 5.5,
          height: compact ? 5 : 5.5,
          borderRadius: '50%',
          bgcolor: 'currentColor',
          opacity: 0.82,
          flexShrink: 0,
        }}
      />
      <Typography component="span" sx={{ fontSize: 'inherit', fontWeight: 'inherit', lineHeight: 1 }}>
        {label}
      </Typography>
    </Box>
  );
};

export default React.memo(TimelineMultipleMomentsIndicator);
